export { default } from './Skeleton';
export type { SkeletonProps } from './Skeleton';
